import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { Spin } from "antd";
import { get } from "library/endpoints";

import * as Styled from '../../components/styled';
import Footer from "screens/Giftcard/components/Footer";

/**
 * 
 * @param {*} props 
 * @returns 
 */
const Callback = (props) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [picture, setPicture] = useState(null)

  useEffect(() => {
    if (props.match.params.method === 'stancer') {
      validateStancerIntent()
    } else if (props.match.params.method === 'paypal') {
      // fetchBasketInfos()
    }
  }, []) // eslint-disable-line

  const validateStancerIntent = async () => {
    try {
      setError(false)
      const response = await get(`/frontend/payment/giftcard/check-stancer-status/${props.match.params.basket}`)
      setPicture(response.data.picture)
      setLoading(false)
      setError(false)
    } catch (error) {
      console.log(error)
      setError(true)
    }
  }

  return (
    <div>
      <Styled.StyledWrapper>
        {
          loading ? (
            <Spin />
          ) : (
            <>
              {
                error ? (
                  <>Une erreur est survenue</>
                ) : (
                  <>
                    {
                      picture && (
                        <img alt="giftcard" src={`${process.env.REACT_APP_S3_FILES_URL}${picture}`} style={{ width: '100%', borderRadius: '3px 3px 0 0', borderBottom: '2px solid #e5e7eb' }} />
                      )
                    }
                    <h1 style={{ textAlign: 'center' }}>Paiement reçu !</h1>
                    <div style={{ padding: 10, color: 'black', fontSize: 14, marginBottom: 10  }}>Merci pour votre achat, un mail de confirmation vous a été envoyé, il contient le lien de téléchargement de votre cadeau</div>
                    <div style={{ padding: 10, color: 'black', fontSize: 14, marginBottom: 10  }}>Selon vos préférences lors de votre achat, un mail a également été envoyé à l'adresse de destination que vous avez indiqué</div>
                  </>
                )
              }
            </>
          )
        }

        <Footer />
      </Styled.StyledWrapper>
    </div>
  )
}

export default withTranslation()(Callback);